import { useSessionSync } from "./hooks/useSessionSync";

export const SessionSyncProvider = () => {
    useSessionSync();
    return null; // No UI, just side effects
};